if (!customElements.get('volume-pricing')) {
  customElements.define(
    'volume-pricing',
    class VolumePricing extends HTMLElement {
      constructor() {
        super();
        this.modalContent = null;
        this.iframe = null;
        this.titleElement = null;
        this.subtitleElement = null;
        
        // Get attributes
        this.dataSource = this.getAttribute('data-source');
        this.dataTitle = this.getAttribute('data-title') || 'Volume Pricing';
        this.modalId = this.generateModalId();
        
        // Create modal element
        this.createModal();
        
        // Add click handler to trigger modal
        this.addEventListener('click', this.handleClick.bind(this));
      }

      generateModalId() {
        // Generate unique ID based on data-source or use timestamp
        const sourceHash = this.dataSource ? 
          this.dataSource.replace(/[^a-zA-Z0-9]/g, '').substring(0, 10) : 
          'default';
        return `VolumePricingModal-${sourceHash}-${Date.now()}`;
      }

      createModal() {
        // Create modal element
        this.modal = document.createElement('volume-pricing-modal');
        this.modal.id = this.modalId;
        this.modal.setAttribute('data-source', this.dataSource);
        this.modal.setAttribute('data-title', this.dataTitle);
        this.modal.classList.add('volume-pricing-modal', 'popup-modal');
        
        // Append modal to body
        document.body.appendChild(this.modal);
      }

      handleClick(event) {
        event.preventDefault();
        if (this.modal) {
          this.modal.show(this);
        }
      }

      connectedCallback() {
        // Set default innerHTML if none provided
        if (!this.innerHTML.trim()) {
          this.innerHTML = '<button class="product-form__submit button button--primary">Volume Pricing Available!</button>';
        }
        
        // Make the component clickable
        this.style.cursor = 'pointer';
        this.setAttribute('role', 'button');
        this.setAttribute('tabindex', '0');
        
        // Add keyboard support
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.handleClick(event);
          }
        });
      }

      disconnectedCallback() {
        // Clean up modal when component is removed
        if (this.modal && this.modal.parentNode) {
          this.modal.parentNode.removeChild(this.modal);
        }
      }
    }
  );

  // Define the modal component
  customElements.define(
    'volume-pricing-modal',
    class VolumePricingModal extends HTMLElement {
      constructor() {
        super();
        this.modalContent = null;
        this.iframe = null;
        this.titleElement = null;
        this.subtitleElement = null;
        
        // Get attributes
        this.dataSource = this.getAttribute('data-source');
        this.dataTitle = this.getAttribute('data-title') || 'Volume Pricing';
        this.modalId = this.id;
      }

      show(opener) {
        // Create modal content if it doesn't exist
        if (!this.modalContent) {
          this.createModalContent();
        }

        // Update iframe source
        this.updateContent();

        // Show the modal
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        
        // Focus management
        if (this.querySelector('[role="dialog"]')) {
          this.querySelector('[role="dialog"]').focus();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }

      createModalContent() {
        // Create the modal content structure
        const contentHTML = `
          <div role="dialog" 
               aria-label="${this.dataTitle}" 
               aria-modal="true" 
               class="volume-pricing-modal__content popup-modal__content custom-scrollbar"
               style="max-width: 850px;"
               tabindex="-1">
            <button id="VolumePricingModalClose-${this.modalId}" 
                    type="button" 
                    class="volume-pricing-modal__toggle tap-target button-control"
                    style="position: fixed;right: 1.5rem;top: 1.5rem;z-index: 4;"
                    aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            
            <div class="volume-pricing-modal__header">
              <h2 class="section-title h4" id="VolumePricingModalTitle-${this.modalId}">${this.dataTitle}</h2>
            </div>
            
            <div class="volume-pricing-modal__body">
              <iframe class="volume-pricing-iframe" 
                      id="VolumePricingIframe-${this.modalId}"
                      width="100%" 
                      height="900px" 
                      type="text/html" 
                      frameborder="0" 
                      allowtransparency="true" 
                      style="border: 0">
              </iframe>
            </div>
          </div>
        `;

        this.innerHTML = contentHTML;
        this.modalContent = this.querySelector('[role="dialog"]');
        this.iframe = this.querySelector('.volume-pricing-iframe');
        this.titleElement = this.querySelector('[id^="VolumePricingModalTitle-"]');
        
        // Add close button event listener
        const closeButton = this.querySelector('[id^="VolumePricingModalClose-"]');
        if (closeButton) {
          closeButton.addEventListener('click', () => this.hide());
        }

        // Add click outside to close
        this.addEventListener('click', (event) => {
          if (event.target === this) {
            this.hide();
          }
        });

        // Add escape key to close
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.hasAttribute('open')) {
            this.hide();
          }
        });
      }

      updateContent() {
        if (!this.iframe || !this.dataSource) return;
        
        // Set iframe source
        this.iframe.src = this.dataSource;
        
        // Handle iframe load
        this.iframe.onload = () => {
          // Optional: Add loading state handling
          this.iframe.style.opacity = '1';
        };
      }
    }
  );
}
